<div class="sh-dashboard-panel">
  <nav class="sh-dashboard-panel__navigation">
    @if (title) {
      <h3 class="sh-page-title--small-subsection sh-dashboard-panel__navigation__title">{{ title }}</h3>
    }

    <ul class="sh-dashboard-navigation__list">
      @for (link of navigationLinks; track link) {
        <li class="sh-dashboard-navigation__list__item">
          <sh-icon-link [item]="link" class="sh-dashboard-navigation__list__link"></sh-icon-link>
        </li>
      }
    </ul>
  </nav>
</div>
